import type { blob_stream_params } from 'backend/src/routes/api/blob-stream';
import { withSpinner } from '@frontend/state/spinner';
import { fetch_with_auth, helper, only_when_authorised } from '.';

export const createDocument = only_when_authorised(withSpinner('Creating Onshape Document', helper('createDocument')));
export const deletePhiModelFromOnshape = only_when_authorised(helper('deletePhiModelFromOnshape'));
export const exportPhiModelAsStep = only_when_authorised(helper('exportPhiModelAsStep'));
export const exportPhiModelToParasolid = only_when_authorised(helper('exportPhiModelToParasolid'));
export const getImage = only_when_authorised(helper('getImage'));
export const getPartBodyDetails = only_when_authorised(helper('getPartBodyDetails'));
export const getPartStudioBodyDetails = only_when_authorised(helper('getPartStudioBodyDetails'));
export const getPartStudioTessellatedEdges = only_when_authorised(helper('getPartStudioTessellatedEdges'));
export const getPartStudioTessellatedFaces = only_when_authorised(helper('getPartStudioTessellatedFaces'));
export const getPartTessellatedEdges = only_when_authorised(helper('getPartTessellatedEdges'));
export const getPartTessellatedFaces = only_when_authorised(helper('getPartTessellatedFaces'));
export const getSettings = only_when_authorised(helper('getSettings'));
export const getUser = only_when_authorised(helper('getUser'));
export const getUserSessionInfo = only_when_authorised(helper('getUserSessionInfo'));
export const health = only_when_authorised(helper('health'));
export const listDocumentElements = only_when_authorised(helper('listDocumentElements'));
export const listDocuments = only_when_authorised(helper('listDocuments'));
export const loadPhiModelFromOnshape = only_when_authorised(helper('loadPhiModelFromOnshape'));
export const log = only_when_authorised(helper('log'));
export const onshapeElementThumbnail = only_when_authorised(helper('onshapeElementThumbnail'));
export const onshapePartThumbnail = only_when_authorised(helper('onshapePartThumbnail'));
export const onshapeThumbnail = only_when_authorised(helper('onshapeThumbnail'));
export const ping = only_when_authorised(helper('ping'));
export const saveSettings = only_when_authorised(helper('saveSettings'));
export const sendPhiModelToOnshape = only_when_authorised(helper('sendPhiModelToOnshape'));
export const shareWithEdu = only_when_authorised(helper('shareWithEdu'));
export const userData = only_when_authorised(helper('userData'));
export const userPurchases = only_when_authorised(helper('userPurchases'));

const blob_helper = helper('loadBlobFromOnshape');
export const loadBlobFromOnshape = only_when_authorised((...xs: Parameters<typeof blob_helper>) =>
    blob_helper(...xs)
        .then(x =>
            x instanceof Error
                ? x
                : Uint8Array.from(atob(x), c => c.charCodeAt(0))));

export const blob_stream = only_when_authorised((x: blob_stream_params): Promise<ArrayBuffer | Error> =>
    fetch_with_auth(new Request('/api/blob-stream', {
        method: 'POST',
        body: JSON.stringify(x),
        headers: { 'Content-Type': 'application/json' },
    })).then(async (x) => x.ok ? await x.arrayBuffer() : new Error(`${x.status} ${x.statusText}`)));
